package ru.it_mozaika.sender.js.application.models

import mui.material.SvgIconProps
import react.ReactElement
import react.create
import ru.it_mozaika.sender.common.models.TemplateType

enum class SenderFeatures(val key: String, val icon: ReactElement<SvgIconProps>, val text: String) {
    STORES("/stores", mui.icons.material.StorefrontSharp.create(), "Магазины"),
    SENDERS("/senders", mui.icons.material.Send.create(), "Отправители"),
    CATALOG("/catalog", mui.icons.material.ShoppingCartSharp.create(), "Каталог товаров"),
    QUARANTINE("/quarantine", mui.icons.material.Block.create(), "Карантин"),
    S3FILES("/s3files", mui.icons.material.BackupSharp.create(), "Хранилище файлов")
}
enum class SubscribesFeatures(val key: String, val icon: ReactElement<SvgIconProps>, val text: String) {
    SUBSCRIBERS("/subscribers", mui.icons.material.People.create(), "Подписчики"),
    PROPERTIES("/properties", mui.icons.material.TextFields.create(), "Пользовательские поля"),
    SUBSCRIPTIONS("/subscriptions", mui.icons.material.List.create(), "Списки подписок"),
    SEGMENTS("/segments", mui.icons.material.FilterAlt.create(), "Сегменты"),
    STATIC_SEGMENTS("/segments/static", mui.icons.material.ArticleSharp.create(), "Статические сегменты"),
}
enum class CampaignsFeatures(val key: String, val icon: ReactElement<SvgIconProps>, val text: String) {
    CAMPAIGNS("/campaigns", mui.icons.material.Public.create(), "Массовые рассылки"),
    STATISTICS("/campaigns/statistics", mui.icons.material.AutoGraph.create(), "Статистика"),
}
enum class TriggersFeatures (val key: String, val icon: ReactElement<SvgIconProps>, val text: String) {
    TRIGGERS("/triggers", mui.icons.material.NotificationsActive.create(), "Триггеры"),
    CATEGORY("/triggers/categories", mui.icons.material.Notes.create(), "Категории триггеров"),
}
enum class TemplatesFeatures(val key: String, val icon: ReactElement<SvgIconProps>, val text: String) {
    TEMPLATES(
        "/templates/${TemplateType.EmailTemplate.urlTitle}",
        mui.icons.material.DesignServices.create(),
        "Шаблоны писем"
    ),
    UNSUBSCRIBE_PAGES(
        "/templates/${TemplateType.Unsubscribe.urlTitle}",
        mui.icons.material.Unsubscribe.create(),
        "Шаблоны страницы отписки"
    ),
    CONFIRM_PAGES(
        "/templates/${TemplateType.Confirm.urlTitle}",
        mui.icons.material.CheckCircleSharp.create(),
        "Шаблоны подтверждения"
    ),
    REVIEWS(
        "/templates/${TemplateType.Review.urlTitle}",
        mui.icons.material.ThumbsUpDownSharp.create(),
        "Шаблоны страницы отзывов"
        )
}
enum class FilesFeatures(val key: String, val icon: ReactElement<SvgIconProps>, val text: String) {
    FILES("/files", mui.icons.material.Folder.create(), "Файлы")
}

enum class AdminFeatures(val key: String, val icon: ReactElement<SvgIconProps>, val text: String) {
    USERS("/users", mui.icons.material.People.create(), "Пользователи"),
}
